import api from './api';

// 로그인
export const login = async (email, password) => {
  const response = await api.post('/auth/login/', {
    email,
    password,
  });
  return response.data;
};

// 로그아웃
export const logout = async () => {
  const response = await api.post('/auth/logout/');
  return response.data;
};

// 현재 사용자 정보 조회
export const getCurrentUser = async () => {
  const response = await api.get('/auth/user/');
  return response.data;
};

// ID 찾기 (이메일 인증)
export const findId = async (email) => {
  const response = await api.post('/auth/find-id/', {
    email,
  });
  return response.data;
};

// 비밀번호 찾기 (이메일 인증)
export const findPassword = async (email) => {
  const response = await api.post('/auth/find-password/', {
    email,
  });
  return response.data;
};

// 비밀번호 변경
export const changePassword = async (oldPassword, newPassword) => {
  const response = await api.post('/auth/change-password/', {
    old_password: oldPassword,
    new_password: newPassword,
  });
  return response.data;
};

